import styled from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { overlayLoad, isLoading } from 'pages/MyAccount/MyAccountStyles';
import { getColor, type Theme } from 'styles/theme';

export const Wrapper = styled.div`
  font-family: ${font.graphikCond};
  height: 100%;

  .overlayLoad {
    ${overlayLoad}
  }

  .isLoading {
    ${isLoading}
  }

  .modal-wrapper {
    width: 288px;

    #modalTitle {
      margin: auto;
    }

    #modalContent {
      padding: 0;
      text-align: center;
    }

    button {
      padding: 8px 16px;
      font-family: ${font.graphikCond};
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      letter-spacing: 0.5px;
    }

    @media (${breakpoint.mdMin}) {
      width: 508px;
      button {
        padding: 16px 32px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;

export const LoaderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 50vh;

  @media (${breakpoint.mdMin}) {
    height: 100%;
  }

  .loader {
    position: absolute;
    left: 48%;
    top: 50%;
    
    @media (${breakpoint.mdMin}) {
      left: 44%;
      top: 44%;
    }
  }
`;

export const StickyHeader = styled.div<{ theme: Theme }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${getColor('borderSecondary')};
  position: relative;

  @media (${breakpoint.mdMax}) {
    margin: 24px 16px 32px;

    .back-button {
      text-transform: capitalize;
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
      margin-left: 0;
      position: absolute;
  
      .arrow-svg {
        margin-bottom: -2px;
        height: 16px;
        width: 16px;
        transform: rotate(-180deg);
      }
    }

    .newsletter-logo {
      width: 156px;
      height: 16px;
      margin: auto;
    }
  }

  @media (${breakpoint.mdMin}) {
    padding-top: 16px;
    position: sticky;
    z-index: 3;
    top: 68px;
    background: ${getColor('neutralLightGray')};
  }
`;

export const SubscriptionsWrapper = styled.div<{ theme: Theme }>`
  border-bottom: 1px solid ${getColor('borderSecondary')};
  padding-bottom: 24px;
  margin: 0 16px 16px;
  scroll-margin-top: 78px;

  @media (${breakpoint.mdMin}) {
    margin-bottom: 24px;
    scroll-margin-top: 150px;
  }

  .create-account {
    margin-top: 16px;
    text-transform: initial;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0.5px;
    padding: 8px 16px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  .unsub-all-btn {
    font-family: ${font.graphikCond};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }

    @media (${breakpoint.mdMin}) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const SubscriptionsTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.5px;

  @media (${breakpoint.mdMin}) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const SubscriptionPlea = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;

  a {
    color: ${getColor('textLink')};
    text-decoration: underline;
  }
`;

export const SubscriptionsList = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: 100%;

  @media (${breakpoint.mmMin}) {
    gap: 16px 20px;
    grid-template-columns: calc(50% - 10px) calc(50% - 10px);
  }

  @media (${breakpoint.xlMin}) {
    gap: 24px 40px;
    grid-template-columns: calc(100%/3 - 80px/3) calc(100%/3 - 80px/3) calc(100%/3 - 80px/3);
  }
`;

export const CarouselHeroWrapper = styled.div`
  margin: 0 16px 50px;

  .wrapper {
    margin-bottom: 16px;
  }

  @media (${breakpoint.xlMin}) {
    .carousel-content {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    margin-bottom: 56px;

    .hero-carousel {
      padding-left: 40px;
    }
  }

  .sub-all-btn {
    font-family: ${font.graphikCond};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-decoration: underline;

    display: block;
    margin-left: auto;
    margin-bottom: 8px;

    @media (${breakpoint.mdMin}) {
      font-size: 16px;
      line-height: 24px;
    }

    @media (${breakpoint.lgMin}) {
      margin-bottom: 16px;
    }
  }
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  letter-spacing: 0.5px;
  margin-bottom: 8px;

  @media (${breakpoint.mdMin}) {
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }
`;

export const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;

  @media (${breakpoint.mdMin}) {
    font-size: 20px;
  }
`;

export const NewslettersWrapper = styled.div`
  scroll-margin-top: 58px;

  @media (${breakpoint.mdMin}) {
    scroll-margin-top: 130px;
  }
`;

export const CategoryWrapper = styled.div`
  padding: 24px;

  &.dark {
    background: ${color.newsletterBackground};
  }

  @media (${breakpoint.mdMax}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const CategoryTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
  border-left: 4px solid ${color.newsletterLine};
  margin-bottom: 24px;
  padding-left: 8px;
`;

export const CategoryList = styled.div`
  display: grid;
  gap: 24px;

  @media (${breakpoint.mdMin}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (${breakpoint.lgMin}) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (${breakpoint.xlMin}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
